import { useCallback } from "react";
import { SinglePeriodMetric } from "./__generated__/SinglePeriodTable.graphql";
import { WorkspaceAnalyticsMetric } from "./__generated__/WorkspaceAnalyticsDetailQuery.graphql";
import { useIntl } from "react-intl";
import { useIntlTokens } from "@/src/components/mobile/useIntlTokens";

export function useMetricToLabel() {
  const intl = useIntl();
  const intl_tokens = useIntlTokens();
  return useCallback(
    (metric: SinglePeriodMetric | WorkspaceAnalyticsMetric) => {
      switch (metric) {
        case "PRODUCT_DATE_TRACKER_REGISTERED":
          return [intl_tokens.Products, intl_tokens.Registered] as const;
        case "PRODUCT_DATE_TRACKER_TASKS_COMPLETED":
          return [intl_tokens.Products, intl_tokens.Resolved] as const;
        case "TASK_EXECUTIONS_COMPLETED":
          return [intl_tokens.Tasks, intl_tokens.Completed] as const;
        case "TODO_ISSUE_CREATED":
          return [intl_tokens.Issues, intl_tokens.Created] as const;
        case "TODO_ISSUE_RESOLVED":
          return [intl_tokens.Issues, intl_tokens.Resolved] as const;
        case "TODO_ISSUE_RESOLVED_AVG_TIME":
          return [
            intl_tokens.Issues,
            intl.formatMessage({
              defaultMessage: "Time to Resolve",
              description: "Workspace Analytics Metric TODO_RESOLVED_AVG_TIME",
            }),
          ] as const;
        case "TODO_CREATED":
          return [intl_tokens.Todos, intl_tokens.Created] as const;
        case "TODO_RESOLVED":
          return [intl_tokens.Todos, intl_tokens.Resolved] as const;
        case "TODO_RESOLVED_AVG_TIME":
          return [
            intl_tokens.Todos,
            intl.formatMessage({
              defaultMessage: "Time to Resolve",
              description: "Workspace Analytics Metric TODO_RESOLVED_AVG_TIME",
            }),
          ] as const;
        case "ENGAGEMENT":
          return [
            intl.formatMessage({
              defaultMessage: "Engagement",
              description: "Workspace Analytics Metric ENGAGEMENT",
            }),
            "",
          ] as const;

        default:
          return [metric, ""] as const;
      }
    },
    [
      intl,
      intl_tokens.Completed,
      intl_tokens.Created,
      intl_tokens.Issues,
      intl_tokens.Products,
      intl_tokens.Registered,
      intl_tokens.Resolved,
      intl_tokens.Tasks,
      intl_tokens.Todos,
    ]
  );
}
